import { render, staticRenderFns } from "./DashboardRta.vue?vue&type=template&id=0cfe5e4b&scoped=true&"
import script from "./DashboardRta.vue?vue&type=script&lang=js&"
export * from "./DashboardRta.vue?vue&type=script&lang=js&"
import style0 from "./DashboardRta.vue?vue&type=style&index=0&id=0cfe5e4b&prod&lang=css&"
import style1 from "./DashboardRta.vue?vue&type=style&index=1&id=0cfe5e4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfe5e4b",
  null
  
)

export default component.exports